import { useEffect } from 'react';

type SeoConfig = {
  title: string;
  description: string;
  canonical: string;
  robots?: string;
  ogType?: string;
  image?: string;
  keywords?: string;
};

const SITE_NAME = 'ViaMedica Balkan';
const DEFAULT_IMAGE = 'https://www.via-medica-balkan.de/og-image.jpeg';

function upsertMetaByName(name: string, content: string) {
  let meta = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function upsertMetaByProperty(property: string, content: string) {
  let meta = document.head.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('property', property);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

export const useSeo = ({
  title,
  description,
  canonical,
  robots = 'index, follow',
  ogType = 'website',
  image = DEFAULT_IMAGE,
  keywords,
}: SeoConfig) => {
  useEffect(() => {
    document.title = title;

    upsertMetaByName('description', description);
    upsertMetaByName('robots', robots);
    if (keywords) {
      upsertMetaByName('keywords', keywords);
    }

    upsertMetaByProperty('og:type', ogType);
    upsertMetaByProperty('og:site_name', SITE_NAME);
    upsertMetaByProperty('og:url', canonical);
    upsertMetaByProperty('og:title', title);
    upsertMetaByProperty('og:description', description);
    upsertMetaByProperty('og:image', image);

    upsertMetaByName('twitter:card', 'summary_large_image');
    upsertMetaByName('twitter:url', canonical);
    upsertMetaByName('twitter:title', title);
    upsertMetaByName('twitter:description', description);
    upsertMetaByName('twitter:image', image);

    upsertCanonical(canonical);
  }, [title, description, canonical, robots, ogType, image, keywords]);
};
